module.exports = __webpack_public_path__ + "static/img/Wallpaper.e1a9ce6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobizone/imgs/browse/Wallpaper.jpg
// module id = 1561
// module chunks = 0